import Vue from 'vue'
import {
  Badge,
  Button,
  Checkbox,
  Dialog,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Form,
  FormItem,
  Input,
  InputNumber,
  Loading,
  Radio,
  Switch,
  Tag,
  Tooltip,
  Pagination,
  TimePicker
} from 'element-ui'
import './element-green/index.css'

Vue.use(Tag)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Dialog)
Vue.use(Input)
Vue.use(Button)
Vue.use(Switch)
Vue.use(Badge)
Vue.use(Loading)
Vue.use(Radio)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Checkbox)
Vue.use(InputNumber)
Vue.use(Tooltip)
Vue.use(Pagination)
Vue.use(TimePicker)
